import { StandardUserRoles } from '@quadminds/shared/commons';
import { MindyStandardRoles } from './roles';

const operationalRoles = [StandardUserRoles.DEFAULT, MindyStandardRoles.OPERATIONAL];
const guestRoles = [StandardUserRoles.DEFAULT, MindyStandardRoles.GUEST];
const consultantRoles = [StandardUserRoles.DEFAULT, MindyStandardRoles.CONSULTANT];
const managerRoles = [...guestRoles, MindyStandardRoles.MANAGER];
const adminRoles = [...managerRoles, MindyStandardRoles.ADMIN];

export const MindyGroupedRoles = {
    operational: {
        roles: operationalRoles,
    },
    guest: {
        roles: guestRoles,
    },
    consultant: {
        roles: consultantRoles,
    },
    manager: {
        roles: managerRoles,
    },
    admin: {
        roles: adminRoles,
    },
};
